import type { RouteApi } from '~/schema/RouteApiSchema'

const endpoint = '/customer'
const endpointWithID = '/customer/{id}'

export const API_CUSTOMER_GET: RouteApi = {
  method: HttpMethod.GET,
  path: endpoint
}

export const API_CUSTOMER_POST: RouteApi = {
  method: HttpMethod.POST,
  path: endpoint
}

export const API_CUSTOMER_PUT: RouteApi = {
  method: HttpMethod.PUT,
  path: endpointWithID
}

export const API_CUSTOMER_DELETE: RouteApi = {
  method: HttpMethod.DELETE,
  path: endpointWithID
}

export const API_CUSTOMER_USER_EXPORT: RouteApi = {
  method: HttpMethod.GET,
  path: `${endpointWithID}/user-export`
}

export const API_CUSTOMER_USER_IMPORT: RouteApi = {
  method: HttpMethod.POST,
  path: `${endpointWithID}/user/import`
}
